"use strict";
module.exports = {
    'v1.alcoholLicense.writeAlcoholLicenses': 'alcoholLicense',
    'v1.alcoholLicense.upsert': 'alcoholLicense',
    'v1.alcoholLicense.upsertWhenEmpty': 'alcoholLicense',
    'v1.alcoholLicense.updateWhenEmpty': 'alcoholLicense',
    'v1.alcoholLicense.update': 'alcoholLicense',
    'v1.alcohol-licenseEventsource.cleanUpOldEvents': 'alcoholLicense',
    'v1.alcohol-licenseEventsource.undoEvent': 'alcoholLicense',
    'v1.alcohol-licenseEventsource.reEmit': 'alcoholLicense',
};
